<template>
    <base-filter
        :status-options="statuses"
        :date-mode="'range'"
        :show-team-members="showTeamMembers"
        :show-carriers="true"
        :show-customer-filter="true"
        :show-quoting-status="showQuotingStatus"
        :show-blank-date-toggle="true"
        :show-status-filter="showStatus"
        :clearable="false"
        :team-region-id="teamRegionId"
        :initial-filters="initialFilters"
        :status-test-id="'shipment-status'"
        :from-date-test-id="'start-date'"
        :to-date-test-id="'end-date'"
        :default-status="'Active'"
        :blank-date-label="'Show shipments with no date first'"
        domain="shipments"
        @onFilterShipments="handleFilterShipments"
    ></base-filter>
</template>
<script>
import { BaseFilter } from '@/components';
import { STATUS_SHIPMENT_CONSTANTS } from '@/utils/constants';
import { titleCase } from '@/helpers';

export default {
    name: 'ShipmentFilterComponent',
    components: { BaseFilter },
    props: {
        teamMembers: {
            type: Function,
            default: () => []
        },
        teamRegionId: {
            type: Number,
            default: null
        },
        showStatus: {
            type: Boolean,
            default: true
        },
        showQuotingStatus: {
            type: Boolean,
            default: false
        },
        showTeamMembers: {
            type: Boolean,
            default: true
        },
        filterValue: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            statuses: ['Active', ...STATUS_SHIPMENT_CONSTANTS, 'All'],
            initialFilters: {
                status: 'Active',
                teamMemberPublicUserId: '',
                carrierTeamId: null,
                teamRegionId: null,
                customerId: null,
                fromDate: null,
                toDate: null,
                quotingStatus: null,
                showBlankDateFirst: false
            }
        };
    },
    watch: {
        filterValue: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.handleFilterSetValue();
                }
            }
        }
    },
    methods: {
        handleFilterShipments(payload) {
            this.$emit('onFilterShipments', payload);
        },
        handleFilterSetValue() {
            if (!this.filterValue) {
                return;
            }

            const updates = {};

            if (this.filterValue.fromDate) {
                updates.fromDate = this.filterValue.fromDate;
            }

            if (this.filterValue.toDate) {
                updates.toDate = this.filterValue.toDate;
            }

            if (this.filterValue.status) {
                updates.status = titleCase(this.filterValue.status);
            }

            if (this.filterValue.teamMemberPublicUserId) {
                updates.teamMemberPublicUserId = this.filterValue.teamMemberPublicUserId;
            }

            if (this.filterValue.teamRegionId) {
                updates.teamRegionId = Number(this.filterValue.teamRegionId);
            }

            if (this.filterValue.customerId) {
                updates.customerId = Number(this.filterValue.customerId);
            }

            if (this.filterValue.carrierTeamId) {
                updates.carrierTeamId = Number(this.filterValue.carrierTeamId);
            }

            if (this.filterValue.quotingStatus) {
                updates.quotingStatus = this.filterValue.quotingStatus;
            }

            if (this.filterValue.showBlankShipmentDateFirst === 'true') {
                updates.showBlankDateFirst = true;
            }

            this.initialFilters = {
                ...this.initialFilters,
                ...updates
            };
        },
        clearFilters() {
            this.initialFilters = {
                status: 'Active',
                teamMemberPublicUserId: '',
                carrierTeamId: null,
                teamRegionId: null,
                customerId: null,
                fromDate: null,
                toDate: null,
                quotingStatus: null,
                showBlankDateFirst: false
            };
        }
    }
};
</script>

<style lang="scss" scoped>
.filter-steps--container {
    ::v-deep .md-field,
    ::v-deep .filter-item {
        display: inline-block;
        width: 200px;
        margin-right: 20px;
        margin-top: 0;
        vertical-align: top;
    }

    ::v-deep .filter-item--checkbox {
        white-space: nowrap;
    }

    ::v-deep .filter-item--checkbox label {
        white-space: nowrap;
    }
}
</style>
